import { Injectable } from '@angular/core';
import { Router, UrlTree } from '@angular/router';

import { DefaultInitialPageUrl, DefaultInitialTab } from '@const';
import { DevFeaturesService } from '@s/dev-features.service';
import { NavigationService } from '@s/navigation.service';

/**
 * Income Machine is hidden while it is reworked: available on Local/Dev environments for developer
 * accounts only (see DevFeaturesService).
 */
@Injectable({
  providedIn: 'root',
})
export class IncomeMachineGuard {
  constructor(
    private devFeaturesService: DevFeaturesService,
    private navigationService: NavigationService,
    private router: Router,
  ) {}

  canActivate(): boolean | UrlTree {
    if (this.devFeaturesService.isEnabled()) {
      return true;
    }

    // Send users who worked with the page before to the home page instead of cancelling the navigation.
    this.navigationService.setActiveTab(DefaultInitialTab);

    return this.router.parseUrl(DefaultInitialPageUrl);
  }
}
